import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from '../../utils/baseQueryFn';


const tourRateBatchAPI = createApi({
    reducerPath: "tourRateBatchAPI",
    baseQuery,
    endpoints: (builder) => ({
        getAllTourRateBatchesWithPage: builder.mutation({
            query: ({ page, size, key }) => {
                const queryParams = new URLSearchParams({
                    page,
                    size
                });

                if(key){
                    queryParams.append('searchKey', key);
                }
    
                const apiUrl = `tour-rate-batch/search?${queryParams.toString()}`;

                return {
                    url: apiUrl,
                    method: "GET",
                };
            },
            transformResponse: (response) => response,
        }),
        getAllTourRateBatches: builder.mutation({
            query: () => ({
                url: `tour-rate-batch/get-list`,
                method: "GET",
            }),
            transformResponse: (response) => response,
        }),
        getTourRateBatchByID: builder.mutation({
            query: (id) => ({
                url: `tour-rate-batch/${id}`,
                method: "GET",
            }),
            transformResponse: (response) => response,
        }),
        createTourRateBatch: builder.mutation({
            query: ({ body }) => ({
                url: `tour-rate-batch/create`,
                method: "POST",
                body
            }),
        }),
        updateTourRateBatch: builder.mutation({
            query: ({ body }) => ({
                url: `tour-rate-batch/update`,
                method: "PUT",
                body
            }),
        }),
        deleteTourRateBatch: builder.mutation({
            query: ({ id }) => ({
                url: `tour-rate-batch/delete/${id}`,
                method: "DELETE"
            }),
        }),
        setDefaultTourRateBatch: builder.mutation({
            query: ({ id }) => ({
                url: `tour-rate-batch/set/default/${id}`,
                method: "PUT"
            }),
        })
    }),
});

export const { 
    useGetAllTourRateBatchesWithPageMutation,
    useGetAllTourRateBatchesMutation,
    useGetTourRateBatchByIDMutation,
    useCreateTourRateBatchMutation,
    useUpdateTourRateBatchMutation,
    useDeleteTourRateBatchMutation,
    useSetDefaultTourRateBatchMutation
} = tourRateBatchAPI;

export default tourRateBatchAPI;